import { BaseApi, configuration } from './base/baseApi'
import { processError } from './fetch'
import { CalculatorSearchParams } from '../util/CalculatorSearchParams'

interface Options {
    method: string
    body?: any
    headers?: any
}

class Api extends BaseApi {

    async hiring(): Promise<any> {
        return this.sendRequest('https://sdk.persona.ly/cms/api/career?page=1&perPage=20')
    }

    async reviews(language): Promise<any> {
        return this.sendRequest('https://sdk.persona.ly/cms/api/testimonial?page=1&perPage=100&language=' + language)
    }

    async blog(numberOnPage): Promise<any> {
        return this.sendRequest('https://persona.ly/blog/wp-json/api/v1/list-posts?records=' + numberOnPage)
    }

    async events(): Promise<any> {
        return this.sendRequest('https://sdk.persona.ly/cms/api/event?page=1&perPage=4')
    }

    async postApplicantCvData(payload): Promise<any> {
        return this.sendRequest('https://sdk.persona.ly/cms/api/jobApplicant', {
            method: 'POST',
            body: payload,
        }, true)
    }

    async postContactFormData(payload): Promise<any> {
        return this.sendRequest('https://sdk.persona.ly/cms/api/user/contact', {
            method: 'POST',
            body: payload
        })
    }

    async postGhostCompletionsFormData(payload): Promise<any> {
        return this.sendRequest(configuration.basePath + '/createsend', {
            method: 'POST',
            body: payload
        })
    }

    async resetPass(email: string): Promise<any> {
        return this.sendRequest('https://sdk.persona.ly/cms/api/user/forgotPassword', {
            method: 'POST',
            body: JSON.stringify({ email })
        })
    }

    async login(email: string, password: string): Promise<any> {
        return this.sendRequest('https://sdk.persona.ly/cms/api/user/signin', {
            method: 'POST',
            body: JSON.stringify({ email, password })
        })
    }

    async register(data): Promise<any> {
        return this.sendRequest('https://sdk.persona.ly/cms/api/user/signup', {
            method: 'POST',
            body: JSON.stringify(data)
        })
    }

    async appStoreApp(bundleId: string, searchParams: CalculatorSearchParams): Promise<any> {
        return this.sendRequest(configuration.basePath + '/get-bundle-info', {
            method: 'POST',
            body: JSON.stringify({ bundleId, ...searchParams })
        })
    }

    async runCalculating(bundleId: string, searchParams: CalculatorSearchParams): Promise<any> {
        return this.sendRequest(configuration.basePath + '/get-bundle-vectors', {
            method: 'POST',
            body: JSON.stringify({ bundleId, ...searchParams })
        })
    }

    private async sendRequest(url: string, options: Options = { method: 'GET' }, multipart?: boolean): Promise<any> {
        try {
            const response = await this.fetch(url, options as any, multipart)
            const json = await response.json()
            return Promise.resolve(json)
        } catch (error) {
            return processError(error)
        }
    }
}

export const api = new Api()



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/api/api.ts